/**
 * Abstract level of fees for a transaction
 */
export var FeesLevel;
(function (FeesLevel) {
    FeesLevel["Slow"] = "slow";
    FeesLevel["Medium"] = "medium";
    FeesLevel["Fast"] = "fast";
})(FeesLevel || (FeesLevel = {}));
export var DeviceModel;
(function (DeviceModel) {
    /**
     * Represents the Ledger Blue hardware device
     */
    DeviceModel["Blue"] = "blue";
    /**
     * Represents the Ledger Nano S hardware device
     */
    DeviceModel["NanoS"] = "nanoS";
    /**
     * Represents the Ledger Nano X hardware device
     */
    DeviceModel["NanoX"] = "nanoX";
})(DeviceModel || (DeviceModel = {}));
/**
 * Enum describing the different types of exchanges.
 */
export var ExchangeType;
(function (ExchangeType) {
    ExchangeType[ExchangeType["SWAP"] = 0] = "SWAP";
    ExchangeType[ExchangeType["SELL"] = 1] = "SELL";
    ExchangeType[ExchangeType["FUND"] = 2] = "FUND";
})(ExchangeType || (ExchangeType = {}));
//# sourceMappingURL=index.js.map